// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 906) return "js/admin/906.js";
	// return url for filenames based on template
	return undefined;
};